const SizesRoutes = {
    createSize: '/admin/create-fittype',
    viewSize: '/admin/get-fittypes',
    deleteSize: "/admin/delete-fittype/",
    updateSize: "/admin/update-fittype/",
}
export default SizesRoutes